import { Controller } from "@hotwired/stimulus"

// Toggles km tracking fields (odometer + photo) based on a checkbox.
// Usage:
//   data-controller="field-shift-km"
//   data-action="change->field-shift-km#toggle" on the checkbox
//   data-field-shift-km-target="fields" on the section to show/hide
export default class extends Controller {
  static targets = ["fields", "checkbox"]

  connect() {
    this.toggle()
  }

  toggle() {
    const tracking = this.checkboxTarget.checked
    this.fieldsTargets.forEach(el => {
      el.classList.toggle("hidden", !tracking)
    })
  }
}
